import type { SyncClient } from '@dovefiniscono/sync';
import { indexedDbStorage } from '@dovefiniscono/sync/web';

// This browser's copy of each user's data: one IndexedDB database per user.

export const localDatabaseName = (userId: string) => `dvf-${userId}`;

const openClients = new Map<string, SyncClient>();

/** Remembers the client using a user's database, so sign-out can close it before deleting. */
export function trackClient(userId: string, client: SyncClient): () => void {
  openClients.set(userId, client);
  return () => {
    if (openClients.get(userId) === client) openClients.delete(userId);
  };
}

/** Deletes the user's local data (on sign-out, for shared computers). */
export async function forgetLocalData(userId: string): Promise<void> {
  // Close first: a write still in flight would otherwise recreate the database after the delete.
  await openClients.get(userId)?.close();
  openClients.delete(userId);
  await indexedDbStorage(localDatabaseName(userId)).clear();
}
